// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2zlx_AbAUXLAsqjQ75fUae{grid-row-gap:1.6rem;display:grid}@media (min-width:1200px){._2zlx_AbAUXLAsqjQ75fUae{grid-column-gap:1.6rem;grid-template-columns:repeat(2,1fr)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productHolder": "_2zlx_AbAUXLAsqjQ75fUae"
};
module.exports = ___CSS_LOADER_EXPORT___;
